import { motion } from 'motion/react';
import { ChevronRight, ChevronLeft } from 'lucide-react';
import type { PlanNavigation as PlanNavType } from '@/types';
import { lightImpact } from '@/utils/haptics';

interface PlanNavigationProps {
  navigation: PlanNavType;
  canAdvance: boolean;
  onAdvance: () => void;
}

const PlanNavigation = ({ navigation, canAdvance, onAdvance }: PlanNavigationProps) => {
  return (
    <div className="space-y-4">
      {/* Segmented progress */}
      <div className="flex gap-1">
        {Array.from({ length: navigation.total }).map((_, i) => (
          <div
            key={i}
            className={`flex-1 h-1.5 rounded-full transition-colors duration-500 ${
              i < navigation.current ? 'bg-amber-500' : 'bg-slate-200 dark:bg-slate-700'
            }`}
          />
        ))}
      </div>

      <div className="flex items-center justify-between">
        <div className="flex flex-col">
          <span className="text-xs font-bold text-slate-700 dark:text-slate-200">
            Step {navigation.current} of {navigation.total}
          </span>
          <span className="text-[11px] text-slate-400 dark:text-slate-500 capitalize">
            {navigation.step}
          </span>
        </div>

        <div className="flex gap-2">
          <motion.button
            whileTap={{ scale: 0.92 }}
            disabled={navigation.previous === 0}
            className="flex items-center gap-1 px-4 py-2.5 rounded-xl text-sm font-medium
                       bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300
                       disabled:opacity-40 disabled:cursor-not-allowed
                       active:bg-slate-200 dark:active:bg-slate-700 transition-colors min-h-12"
          >
            <ChevronLeft className="w-4 h-4" />
            Prev
          </motion.button>
          <motion.button
            whileTap={{ scale: 0.92 }}
            onClick={async () => { await lightImpact(); onAdvance(); }}
            disabled={!canAdvance}
            className="flex items-center gap-1 px-4 py-2.5 rounded-xl text-sm font-bold
                       bg-amber-500 text-white
                       disabled:opacity-40 disabled:cursor-not-allowed
                       active:bg-amber-600 transition-colors min-h-12 shadow-md"
          >
            Next
            <ChevronRight className="w-4 h-4" />
          </motion.button>
        </div>
      </div>
    </div>
  );
};

export default PlanNavigation;
